import { isApiErrorDto } from "../../../common/errors/isApiErrorDto";
import { isFetchBaseQueryError } from "../../../common/errors/isFetchBaseQueryError";

const STANDSTILL_EXEMPTION_NOT_APPLICABLE = "zz_SourcingEventApiErrorCode_StandstillExemptionNotApplicable";

export const isStandstillExemptionRefusal = (e: unknown): boolean =>
  e != null && isFetchBaseQueryError(e) && isApiErrorDto(e.data) && e.data.errorCode === STANDSTILL_EXEMPTION_NOT_APPLICABLE;
